module.exports = __webpack_public_path__ + "87ec37c266abe289579d26c24286e824.png";